import { push } from "connected-react-router";
import React, { useState, useMemo } from "react";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
  LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  ROUTE_PATH,
  APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE,
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION,
  LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION,
  LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION,
  LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL,
  LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL,
  APPLICATION_MODE_RENEW,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION,
  LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION
  // APPLICATION_MODE_NEW,
  // APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
} from "../../app/constants";
import { useDispatch, useSelector } from "react-redux";
import { decideLegalAndOperatingNames, replaceUrlParams, ValidateString } from "../../app/utils";
import { CanadaProvinceList } from "../../app/constants";
import { Button, ErrorMark, Paragraph } from "../../components/RegularComponents";
import CheckboxForm from "../../components/CheckBoxForm";
import { ERROR_STRING, VALIDATION_TYPE, VALIDATION_ERROR } from "../../app/errors";
// import { ERROR_STRING } from "../../app/errors";
// import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { setCompanyRjscDetails } from "../../redux/slice/rjscDetailReviewSlice";
import { setCompanyTrademark } from "../../redux/slice/primaryAgencyApplicationSlice";
import { ErrorWithString } from "../../components/RegularComponents";
// import { setMortgageProperty } from "../../redux/slice/primaryAgencyApplicationSlice";
import TopNavigationBar from "../TopNavigationBar";
import styles from "./mra.module.scss";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { applicationTypeFromLicenceSubType } from "../../redux/slice/applicationsUtils";

//  const APPOINTED_AGENT_MORTGAGE_APPLICATION_PROPERTY = "responsibleAgent";
//  const SERVICE_ADDRESS_MORTGAGE_APPLICATION_PROPERTY = "serviceBusinessAddress";

export const MraRJSCEnterCompanyInfo = (props) => {
  const { isModal = false, onEditSave = () => {} } = props;
  const dispatch = useDispatch();

  // const companyRjscDetails = useSelector(
  //   (state) =>
  //     state.primaryAgencyApplication?.application?.businessLicenceData
  //       ?.companyRjscDetails ?? {}
  // );

  const { mraApplicationState, licencingSubType } = useSelector((state) => ({
    licencingSubType:
      state.primaryAgencyApplication.application?.licencingSubType ??
      LICENCE_SUB_TYPE_MORTGAGE_BROKERAGE_NEW_APPLICATION,
    mraApplicationState: state.primaryAgencyApplication.application?.businessLicenceData ?? {}
  }));

  const { companyRjscDetails, companyTrademark } = mraApplicationState;

  const { peopleList } = companyRjscDetails?.businessData;

  //    const applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE;
  //    const applicationMode = APPLICATION_MODE_NEW;
  //    const [applicationSaveError, setApplicationSaveError] = useState(false);

  //    const appointedAgent = useSelector(
  //      (state) =>
  //        state.primaryAgencyApplication.application?.businessLicenceData
  //          ?.responsibleAgent ?? {}
  //    );

  //    const serviceBusinessAddress = useSelector(
  //      (state) =>
  //        state.primaryAgencyApplication.application?.businessLicenceData
  //            ?.serivceBusinessAddress ?? {}
  //    )

  // let initialCompanyLegalName = "N/A"
  // let initialCompanyOperatingName = "N/A"

  // if(companyRjscDetails?.businessEntity?.businessName && !companyRjscDetails?.businessData?.businessOwner) {
  //   initialCompanyLegalName = businessEntity?.businessName
  //   initialCompanyOperatingName = "N/A"
  // } else if(companyRjscDetails?.businessEntity?.businessName && companyRjscDetails?.businessData?.businessOwner) {
  //   initialCompanyLegalName = businessData?.businessOwner
  //   initialCompanyOperatingName = businessEntity?.businessName
  // } else if(!companyRjscDetails?.businessEntity?.businessName && companyRjscDetails?.businessData?.businessOwner) {
  //   initialCompanyLegalName = businessData?.businessOwner
  //   initialCompanyOperatingName = "N/A"
  // }

  const companyNames = decideLegalAndOperatingNames(companyRjscDetails);

  const [businessName, setBusinessName] = useState(companyNames.legalName);
  const [businessNameError, setBusinessNameError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [operatingName, setOperatingName] = useState(companyNames.operatingName);
  const [tradeMark, setTradeMark] = useState(companyTrademark);

  const [civicAddress, setCivicAddress] = useState(
    companyRjscDetails?.businessContact?.civicAddress?.street
  );
  const [civicAddressError, setCivicAddressError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [city, setCity] = useState(companyRjscDetails?.businessContact?.civicAddress?.city);
  const [province, setProvince] = useState(
    companyRjscDetails?.businessContact?.civicAddress?.province
  );
  const [cityError, setCityError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [showValidationError, setShowValidationError] = useState(false);
  const [provinceError, setProvinceError] = useState(false);
  const [postalCode, setPostalCode] = useState(
    companyRjscDetails?.businessContact?.civicAddress?.postalCode
  );
  const [postalCodeError, setPostalCodeError] = useState(VALIDATION_ERROR.NO_ERROR);

  const [mailingAddress, setMailingAddress] = useState(
    companyRjscDetails?.businessContact?.mailingAddress?.street
  );
  const [mailingAddressError, setMailingAddressError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [mailingCity, setMailingCity] = useState(
    companyRjscDetails?.businessContact?.mailingAddress?.city
  );
  const [mailingProvince, setMailingProvince] = useState(
    companyRjscDetails?.businessContact?.mailingAddress?.province
  );
  const [mailingCityError, setMailingCityError] = useState(VALIDATION_ERROR.NO_ERROR);
  const [mailingProvinceError, setMailingProvinceError] = useState(false);
  const [mailingPostalCode, setMailingPostalCode] = useState(
    companyRjscDetails?.businessContact?.mailingAddress?.postalCode
  );
  const [mailingPostalCodeError, setMailingPostalCodeError] = useState(VALIDATION_ERROR.NO_ERROR);

  const [confirmCheck, setConfirmCheck] = useState(false);

  const provinceOptionElements = useMemo(() => {
    return Object.keys(CanadaProvinceList).map((key) => {
      const element = CanadaProvinceList[key];
      return (
        <option key={key} value={element}>
          {element}
        </option>
      );
    });
  }, []);

  const validateData = () => {
    const ret1 = ValidateString(businessName, VALIDATION_TYPE.STRING_NON_EMPTY);
    setBusinessNameError(ret1);

    const ret2 = ValidateString(civicAddress, VALIDATION_TYPE.STRING_NON_EMPTY);
    setCivicAddressError(ret2);

    const ret3 = ValidateString(city, VALIDATION_TYPE.STRING_NON_EMPTY);
    setCityError(ret3);

    const ret4 = !province || province === "unknown";

    if (ret4) {
      setProvinceError("Select a province");
    }

    const ret5 = ValidateString(postalCode, VALIDATION_TYPE.STRING_NON_EMPTY);
    setPostalCodeError(ret5);

    if (confirmCheck) {
      if (
        ValidateString(mailingAddress, VALIDATION_TYPE.STRING_NON_EMPTY) !==
        VALIDATION_ERROR.NO_ERROR
      ) {
        setMailingAddressError(VALIDATION_ERROR.EMPTY);
        return false;
      }

      if (
        ValidateString(mailingCity, VALIDATION_TYPE.STRING_NON_EMPTY) !== VALIDATION_ERROR.NO_ERROR
      ) {
        setMailingCityError(VALIDATION_ERROR.EMPTY);
        return false;
      }

      if (
        ValidateString(mailingPostalCode, VALIDATION_TYPE.STRING_NON_EMPTY) !==
        VALIDATION_ERROR.NO_ERROR
      ) {
        setMailingPostalCodeError(VALIDATION_ERROR.EMPTY);
        return false;
      }

      if (!mailingProvince || mailingProvince === "unknown") {
        setMailingProvinceError(VALIDATION_ERROR.EMPTY);
        return false;
      }
    }

    return (
      ret1 === VALIDATION_ERROR.NO_ERROR &&
      ret2 === VALIDATION_ERROR.NO_ERROR &&
      ret3 === VALIDATION_ERROR.NO_ERROR &&
      !ret4 &&
      ret5 === VALIDATION_ERROR.NO_ERROR
    );
  };

  const handleNext = () => {
    // setApplicationSaveError(false);
    //reset errors
    setShowValidationError(false);
    setBusinessNameError(VALIDATION_ERROR.NO_ERROR);
    setCivicAddressError(VALIDATION_ERROR.NO_ERROR);
    setCityError(VALIDATION_ERROR.NO_ERROR);
    setProvinceError(false);
    setPostalCodeError(VALIDATION_ERROR.NO_ERROR);

    setMailingAddressError(VALIDATION_ERROR.NO_ERROR);
    setMailingCityError(VALIDATION_ERROR.NO_ERROR);
    setMailingProvinceError(false);
    setMailingPostalCodeError(VALIDATION_ERROR.NO_ERROR);

    if (!validateData()) {
      setShowValidationError(true);
      return;
    }

    const updatedCompanyRJSCData = {
      authorized: false,
      status: "ACTIVE",
      businessContact: {
        civicAddress: {
          city: city,
          postalCode: postalCode,
          province: province,
          street: civicAddress
        },
        email: null,
        fax: null,
        mailingAddress: {
          city: confirmCheck ? mailingCity : city,
          postalCode: confirmCheck ? mailingPostalCode : postalCode,
          province: confirmCheck ? mailingProvince : province,
          street: confirmCheck ? mailingAddress : civicAddress
        },
        phoneNumber: null
      },
      businessData: {
        businessOwner: !operatingName ? null : businessName,
        companyType: "Business Name",
        companyTypeId: null,
        expiryDate: "",
        peopleList: peopleList || [],
        phoneNumber: null,
        relatedTo: "N/A"
      },
      businessEntity: {
        businessName: operatingName ? operatingName : businessName,
        entityId: "",
        registryNumber: "N/A"
      }
    };

    dispatch(
      setCompanyRjscDetails({
        ...companyRjscDetails,
        ...updatedCompanyRJSCData
      })
    );

    if (tradeMark) {
      dispatch(setCompanyTrademark(tradeMark));
    }

    let nextUrl = `${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_RJSC_COMPANY_OFFICIALS}`;

    let applicationType = APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE;
    let applicationMode = APPLICATION_MODE_NEW;

    if (licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION || licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_LENDER_RENEWAL_APPLICATION) {
      applicationType = APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE;
      nextUrl = `${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_RJSC_COMPANY_OFFICIALS}`;
    }

    if (licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_NEW_APPLICATION || licencingSubType === LICENCE_SUB_TYPE_MORTGAGE_ADMINISTRATOR_RENEWAL_APPLICATION) {
      applicationType = APPLICATION_TYPE_MORTGAGE_ADMINISTRATOR_LICENCE;
      nextUrl = `${ROUTE_PATH.ML_APP}${ROUTE_PATH.ML_RJSC_COMPANY_OFFICIALS}`;
    }

    if (
      licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_APPLICATION ||
      licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL ||
      licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_APPLICATION ||
      licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
    ) {
      applicationType = applicationTypeFromLicenceSubType(licencingSubType);
      if (
        licencingSubType === LICENCE_SUB_TYPE_COLLECTION_AGENCY_RENEWAL ||
        licencingSubType === LICENCE_SUB_TYPE_DEBT_MANAGEMENT_RENEWAL
      ) {
        applicationMode = APPLICATION_MODE_RENEW;
      }

      nextUrl = replaceUrlParams(
        ROUTE_PATH.RJSC_COMPANY_OFFICIALS,
        applicationType,
        applicationMode
      );
    }

    if (!isModal) {
      dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode)).then(
        (data) => {
          dispatch(push(nextUrl));
        }
      );
    } else {
      onEditSave();
    }
  };

  const handleBusinessNameChange = (e) => {
    setBusinessName(e.target.value);
    setBusinessNameError(VALIDATION_ERROR.NO_ERROR);
  };

  const handleOperatingNameChange = (e) => {
    setOperatingName(e.target.value);
  };

  const handleTradeMarkChange = (e) => {
    setTradeMark(e.target.value);
  };

  const handleCivicAddressChange = (e, type = "civic") => {
    if (type === "mailing") {
      setMailingAddress(e.target.value);
      setMailingAddressError(VALIDATION_ERROR.NO_ERROR);
    } else {
      setCivicAddress(e.target.value);
      setCivicAddressError(VALIDATION_ERROR.NO_ERROR);
    }
  };

  const handleCityChange = (e, type = "civic") => {
    if (type === "mailing") {
      setMailingCity(e.target.value);
      setMailingCityError(VALIDATION_ERROR.NO_ERROR);
    } else {
      setCity(e.target.value);
      setCityError(VALIDATION_ERROR.NO_ERROR);
    }
  };

  const handlePostalCodeChange = (e, type = "civic") => {
    if (type === "mailing") {
      setMailingPostalCode(e.target.value);
      setMailingPostalCodeError(VALIDATION_ERROR.NO_ERROR);
    } else {
      setPostalCode(e.target.value);
      setPostalCodeError(VALIDATION_ERROR.NO_ERROR);
    }
  };

  const handleMailingCivicAddressChange = (e) => {
    handleCivicAddressChange(e, "mailing");
  };

  const handleMailingCityChange = (e) => {
    handleCityChange(e, "mailing");
  };

  const handleMailingPostalCodeChange = (e) => {
    handlePostalCodeChange(e, "mailing");
  };

  return (
    <div className={!isModal ? "container" : ""}>
      {!isModal && (
        <>
          <TopNavigationBar {...props} />
          {/* Title */}
          <div className="row">
            <div className="col-xs-12 col-lg-10">
              <h1>Enter Business Information</h1>
            </div>
          </div>
        </>
      )}

      {/* Business Name */}
      <div style={{ marginTop: "30px" }} className="row">
        <div className="col-lg-8">
          <h2>Company Information</h2>
        </div>
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"rjsc-company-info-businessName-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"rjsc-company-info-businessName-text"}
            >
              Legal Business Name
            </label>
            {businessNameError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"rjsc-company-info-businessName-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(businessNameError)}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (!businessNameError !== VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"rjsc-company-info-businessName-text"}
              name={"rjsc-company-info-businessName-text"}
              value={businessName}
              onChange={handleBusinessNameChange}
            />
          </fieldset>
        </div>
      </div>

      {/* Operating Name */}
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"rjsc-company-info-operatingName-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"rjsc-company-info-operatingName-text"}
            >
              Operating Name
            </label>
            <span style={{ display: "block" }}>If different from legal name</span>
            <input
              type="text"
              className={"fw-25 ns-input"}
              id={"rjsc-company-info-operatingName-text"}
              name={"rjsc-company-info-operatingName-text"}
              value={operatingName}
              onChange={handleOperatingNameChange}
            />
          </fieldset>
        </div>
      </div>

      {/* Trade Mark */}
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"rjsc-company-info-tradeMark-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"rjsc-company-info-tradeMark-text"}
            >
              Trade Mark
            </label>
            <span style={{ display: "block" }}>
              If applicable, enter your company's federally registered trademark
            </span>
            <input
              type="text"
              className={"fw-25 ns-input"}
              id={"rjsc-company-info-tradeMark-text"}
              name={"rjsc-company-info-tradeMark-text"}
              value={tradeMark}
              onChange={handleTradeMarkChange}
            />
          </fieldset>
        </div>
      </div>

      {/* CivicAddress */}
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"rjsc-company-info-civicAddress-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"rjsc-company-info-civicAddress-text"}
            >
              Civic Address
            </label>
            {civicAddressError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"rjsc-company-info-civicAddress-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(civicAddressError)}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (!civicAddressError !== VALIDATION_ERROR.NO_ERROR
                  ? " ns-input"
                  : " ns-input--error")
              }
              id={"rjsc-company-info-civicAddress-text"}
              name={"rjsc-company-info-civicAddress-text"}
              value={civicAddress}
              onChange={handleCivicAddressChange}
            />
          </fieldset>
        </div>
      </div>

      {/* City */}
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"rjsc-company-info-city-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"rjsc-company-info-city-text"}
            >
              City
            </label>
            {cityError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"rjsc-company-info-city-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(cityError)}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (!cityError !== VALIDATION_ERROR.NO_ERROR ? " ns-input" : " ns-input--error")
              }
              id={"rjsc-company-info-city-text"}
              name={"rjsc-company-info-city-text"}
              value={city}
              onChange={handleCityChange}
            />
          </fieldset>
        </div>
      </div>

      {/* Province Select section */}
      <div className="row">
        <div className="col-lg-8">
          <div className={"ns-fieldset" + (provinceError ? " ns-fieldset-message-error" : "")}>
            <label
              id={"rjsc-company-info-province-label"}
              className="ns-label"
              htmlFor={"rjsc-company-info-province-input"}
            >
              Province
            </label>
            {provinceError && (
              <span
                id={"rjsc-company-info-province-input-error"}
                className="ns-error-message fieldset-validation-error"
              >
                {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_PROVINCE_EMPTY)}
              </span>
            )}
            <div className="select fw-25 inlineDisplay">
              <select
                className={provinceError ? "select--error" : ""}
                style={{ width: "25em" }}
                id={"rjsc-company-info-province-select-input"}
                name={"rjsc-company-info-province-select-input"}
                value={province}
                onChange={(e) => {
                  setProvince(e.target.value);
                }}
              >
                {provinceOptionElements}
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Postal Code */}
      <div className="row">
        <div className="col-lg-8">
          <fieldset className="ns-fieldset">
            <label
              id={"rjsc-company-info-postalCode-label"}
              className="ns-label"
              autoComplete="postal-code"
              htmlFor={"rjsc-company-info-postalCode-text"}
            >
              Postal Code
            </label>
            {postalCodeError !== VALIDATION_ERROR.NO_ERROR && (
              <span
                id={"rjsc-company-info-postalCode-text-error"}
                className="ns-error-message field-validation-error"
              >
                {ErrorWithString(postalCodeError)}
              </span>
            )}
            <input
              type="text"
              className={
                "fw-25" +
                (!postalCodeError !== VALIDATION_ERROR.NO_ERROR ? " ns-input" : " ns-input--error")
              }
              id={"rjsc-company-info-postalCode-text"}
              name={"rjsc-company-info-postalCode-text"}
              value={postalCode}
              onChange={handlePostalCodeChange}
            />
          </fieldset>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-1">
          <CheckboxForm
            id="rjsc-company-info-checkbox"
            value={confirmCheck}
            labelStyle={{ fontWeight: "normal !important" }}
            onCheckBoxChange={(val) => {
              setShowValidationError(false);
              setConfirmCheck(val);

              if (val) {
                // mailing is different
                setMailingAddress("");
                setMailingCity("");
                setMailingPostalCode("");
                setMailingProvince("");
              } else {
                // mailing is same
                setMailingAddress(civicAddress);
                setMailingCity(city);
                setMailingPostalCode(postalCode);
                setMailingProvince(province);
              }
            }}
          />
        </div>
        <div className="col-lg-11">
          <Paragraph
            style={{ marginLeft: "-20px", paddingTop: "5px" }}
            id="rjsc-company-info-header"
            text={["Mailing address is different than civic address"]}
          />
        </div>
      </div>

      {confirmCheck && (
        <div style={{ marginLeft: "10px" }}>
          {/* Mailing Civic Address */}
          <div className="row">
            <div className="col-lg-8">
              <fieldset className="ns-fieldset">
                <label
                  id={"rjsc-company-info-mailing-civicAddress-label"}
                  className="ns-label"
                  autoComplete="postal-code"
                  htmlFor={"rjsc-company-info-mailing-civicAddress-text"}
                >
                  Street Address
                </label>
                {mailingAddressError !== VALIDATION_ERROR.NO_ERROR && (
                  <span
                    id={"rjsc-company-info-mailing-civicAddress-text-error"}
                    className="ns-error-message field-validation-error"
                  >
                    {ErrorWithString(mailingAddressError)}
                  </span>
                )}
                <input
                  type="text"
                  className={
                    "fw-25" +
                    (!mailingAddressError !== VALIDATION_ERROR.NO_ERROR
                      ? " ns-input"
                      : " ns-input--error")
                  }
                  id={"rjsc-company-info-mailing-civicAddress-text"}
                  name={"rjsc-company-info-mailing-civicAddress-text"}
                  value={mailingAddress}
                  onChange={handleMailingCivicAddressChange}
                />
              </fieldset>
            </div>
          </div>

          {/* City */}
          <div className="row">
            <div className="col-lg-8">
              <fieldset className="ns-fieldset">
                <label
                  id={"rjsc-company-info-city-label"}
                  className="ns-label"
                  autoComplete="postal-code"
                  htmlFor={"rjsc-company-info-city-text"}
                >
                  City
                </label>
                {mailingCityError !== VALIDATION_ERROR.NO_ERROR && (
                  <span
                    id={"rjsc-company-info-city-text-error"}
                    className="ns-error-message field-validation-error"
                  >
                    {ErrorWithString(mailingCityError)}
                  </span>
                )}
                <input
                  type="text"
                  className={
                    "fw-25" +
                    (!mailingCityError !== VALIDATION_ERROR.NO_ERROR
                      ? " ns-input"
                      : " ns-input--error")
                  }
                  id={"rjsc-company-info-city-text"}
                  name={"rjsc-company-info-city-text"}
                  value={mailingCity}
                  onChange={handleMailingCityChange}
                />
              </fieldset>
            </div>
          </div>

          {/* Province Select section */}
          <div className="row">
            <div className="col-lg-8">
              <div
                className={
                  "ns-fieldset" + (mailingProvinceError ? " ns-fieldset-message-error" : "")
                }
              >
                <label
                  id={"rjsc-company-info-province-label"}
                  className="ns-label"
                  htmlFor={"rjsc-company-info-province-input"}
                >
                  Province
                </label>
                {mailingProvinceError && (
                  <span
                    id={"rjsc-company-info-province-input-error"}
                    className="ns-error-message fieldset-validation-error"
                  >
                    {ErrorWithString(ERROR_STRING.CONTACT_DETAILS_PROVINCE_EMPTY)}
                  </span>
                )}
                <div className="select fw-25 inlineDisplay">
                  <select
                    className={mailingProvinceError ? "select--error" : ""}
                    style={{ width: "25em" }}
                    id={"rjsc-company-info-province-select-input"}
                    name={"rjsc-company-info-province-select-input"}
                    value={mailingProvince}
                    onChange={(e) => {
                      setMailingProvince(e.target.value);
                    }}
                  >
                    {provinceOptionElements}
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Postal Code */}
          <div className="row">
            <div className="col-lg-8">
              <fieldset className="ns-fieldset">
                <label
                  id={"rjsc-company-info-postalCode-label"}
                  className="ns-label"
                  autoComplete="postal-code"
                  htmlFor={"rjsc-company-info-postalCode-text"}
                >
                  Postal Code
                </label>
                {mailingPostalCodeError !== VALIDATION_ERROR.NO_ERROR && (
                  <span
                    id={"rjsc-company-info-postalCode-text-error"}
                    className="ns-error-message field-validation-error"
                  >
                    {ErrorWithString(mailingPostalCodeError)}
                  </span>
                )}
                <input
                  type="text"
                  className={
                    "fw-25" +
                    (!mailingPostalCodeError !== VALIDATION_ERROR.NO_ERROR
                      ? " ns-input"
                      : " ns-input--error")
                  }
                  id={"rjsc-company-info-postalCode-text"}
                  name={"rjsc-company-info-postalCode-text"}
                  value={mailingPostalCode}
                  onChange={handleMailingPostalCodeChange}
                />
              </fieldset>
            </div>
          </div>
        </div>
      )}

      {/* Save and continue */}
      <div className="row">
        <div className={"col-lg-4" + (showValidationError ? " has-error" : "")}>
          <Button
            className={`${styles["question_button"]} btn-lg btn-default`}
            style={{ margin: "0 10px 10px 0" }}
            buttonType={"regular_primary"}
            onClick={handleNext}
            text={!isModal ? "Save and next" : "Save and close"}
          />
          {/* {applicationSaveError && !isModal && ErrorMark()}
          {applicationSaveError && !isModal && (
            <div className="ns-error-message help-block topMarginNormal">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.APPLICATION_SAVE_ERROR}
            </div>
          )} */}
          {showValidationError && ErrorMark()}
          {showValidationError && (
            <div className="ns-error-message">
              <span className="ns-visually-hidden">Error:</span>
              {ERROR_STRING.CHECK_FIELDS}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
